import { render, staticRenderFns } from "./LoginDialogButton.vue?vue&type=template&id=63467325&scoped=true"
import script from "./LoginDialogButton.vue?vue&type=script&lang=js"
export * from "./LoginDialogButton.vue?vue&type=script&lang=js"
import style0 from "./LoginDialogButton.vue?vue&type=style&index=0&id=63467325&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63467325",
  null
  
)

export default component.exports